<template>
    <div>
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <h3 class="mb-0">{{ activeItem.type }}</h3>
            {{ activeItem.kind }} - {{ activeItem.brand }}
            <b-table bordered hover show-empty no-local-sorting :items="items" :fields="fields" responsive class="my-3"
                @sort-changed="onSortChanged">
                <template v-slot:empty>
                    Tidak ada data tahun / generasi.
                </template>
                <template v-slot:cell(price)="row">
                    <div>Rp. {{ $helper.formatThousand(row.item.price) }}</div>
                </template>
                <template v-slot:cell(adj_batangan)="row">
                    <div v-if="!row.item.isEditing">
                        <div v-if="row.item.adj_batangan == null" class="text-muted">Tidak ada Batangan</div>
                        <div v-else>Rp. {{ $helper.formatThousand(row.item.adj_batangan) }}</div>
                    </div>
                    <div v-else>
                        <b-form-group label="Batangan">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="row.item.editBatangan"
                                    @input="sanitize(row.index, row.item, 'editBatangan')"
                                    :disabled="row.item.isSubmitting"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </div>
                </template>
                <template v-slot:cell(adj_grade_s)="row">
                    <div v-if="!row.item.isEditing">
                        <div v-if="row.item.adj_grade_s == null" class="text-muted">Tidak ada Grade S</div>
                        <div v-else>Rp. {{ $helper.formatThousand(row.item.adj_grade_s) }}</div>
                    </div>
                    <div v-else>
                        <b-form-group label="Grade S">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="row.item.editGradeS"
                                    @input="sanitize(row.index, row.item, 'editGradeS')"
                                    :disabled="row.item.isSubmitting"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </div>
                </template>
                <template v-slot:cell(specs)="row">
                    <div v-if="!row.item.isEditing">
                        <div v-if="row.item.hasSpecs">
                            <table class="w-100" style="border:none;">
                                <tr v-for="(value, spec, index) in row.item.specs"
                                    style="border:none;background-color:unset !important;" :key="'spek-' + index">
                                    <td v-if="value.adj !== ''" style="border:none; padding:0px;width:80px;">{{ spec }}
                                    </td>
                                    <td v-if="value.adj !== ''" style="border:none; padding:0px;">: Rp. {{
            $helper.formatThousand(value.adj) }}</td>
                                </tr>
                            </table>
                        </div>
                        <div v-else class="text-muted">Tidak ada Adjustment Spek</div>
                    </div>
                    <div v-else>
                        <b-form-group v-for="(value, spec, index) in row.item.editSpecs" :key="'spek-edit-' + index"
                            :label="'Spek ' + spec">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="row.item.editSpecs[spec].adj"
                                    @input="sanitize(row.index, row.item, spec)"
                                    :disabled="row.item.isSubmitting"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <div v-if="!row.item.isEditing">
                        <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail"
                            @click="$emit('show-detail', row.item.id)">
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                        <!-- <b-button size="sm" class="ml-2" variant="primary" v-b-tooltip.hover.top title="Adjust Harga"
                            @click="toggleEditSpec(row.index, row.item)">
                            <i class="fa fa-fw fa-list-alt" />
                        </b-button> -->
                        <router-link class="ml-2" :to="'/master/barang/y/' + row.item.id">
                            <b-button size="sm" variant="warning" v-b-tooltip.hover.top title="Edit">
                                <i class='fa fa-fw fa-pencil' />
                            </b-button>
                        </router-link>
                    </div>
                    <div v-else>
                        <b-button size="sm" variant="danger" :disabled="row.item.isSubmitting" v-b-tooltip.hover.top
                            title="Batal Adjust" @click="toggleEditSpec(row.index, row.item)">
                            <i class="fa fa-fw fa-close" />
                        </b-button>
                        <b-button size="sm" class="ml-2" variant="success" :disabled="row.item.isSubmitting"
                            v-b-tooltip.hover.top title="Simpan" @click="saveSpec(row.index)">
                            <i class="fa fa-fw fa-check" />
                        </b-button>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,

            fields: [
                { key: "year", label: "Tahun / Generasi", sortable: true },
                { key: "price", label: "Harga Dasar", sortable: true },
                { key: "adj_batangan", label: "Adj. Batangan", sortable: true },
                { key: "adj_grade_s", label: "Adj. Grade S", sortable: true },
                { key: "specs", label: "Adj. Spek Non Ori" },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

        }
    },
    props: {
        activeItem: { type: Object, required: true }
    },
    methods: {

        init() {

            this.getItems()

        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getItems() {
            this.initStatus = 0
            this.$axios.get(`master/item/years/${this.activeItem.id}`).then(res => {

                this.initStatus = 1

                this.items = res.data.data.map(item => {
                    let editSpecs = {}
                    let specs = {}
                    let hasSpecs = false
                    for (let i = 0; i < item.itemSpecs.length; i++) {
                        editSpecs[item.itemSpecs[i].name] = {
                            id: item.itemSpecs[i].id,
                            adj: ""
                        }
                        specs[item.itemSpecs[i].name] = {
                            id: item.itemSpecs[i].id,
                            adj: ""
                        }

                        if (item.type_prices != null) {
                            for (let j = 0; j < item.type_prices.length; j++) {
                                if (item.itemSpecs[i].id == item.type_prices[j].id) {
                                    specs[item.itemSpecs[i].name].adj = item.type_prices[j].adj
                                    hasSpecs = true
                                    break
                                }
                            }
                        }
                    }
                    return {
                        id: item.id,
                        year: item.year,
                        price: item.price,
                        adj_batangan: item.adj_batangan,
                        adj_grade_s: item.adj_grade_s,
                        specs: specs,
                        editBatangan: "",
                        editGradeS: "",
                        editSpecs: editSpecs,
                        hasSpecs: hasSpecs,
                        isEditing: false,
                        isSubmitting: false
                    }
                })

            })
                .catch(error => {
                    this.initStatus = -1
                })
        },

        toggleEditSpec(index, item) {
            if (!this.items[index].isEditing) {
                this.items[index].editBatangan = this.items[index].adj_batangan
                this.items[index].editGradeS = this.items[index].adj_grade_s
                for (const [key, value] of Object.entries(this.items[index].specs)) {
                    this.items[index].editSpecs[key].adj = value.adj
                }
                this.items[index].isEditing = true
            }
            else {
                this.items[index].editBatangan = ""
                this.items[index].editGradeS = ""
                for (const [key, _] of Object.entries(this.items[index].editSpecs)) {
                    this.items[index].editSpecs[key].adj = ""
                }
                this.items[index].isEditing = false
            }

            this.sanitizeAll(index, item)
        },

        saveSpec(index) {

            this.items[index].isSubmitting = true

            // this.items[index].editSpecs.BM.adj = (this.items[index].editSpecs.BM.adj ? this.$helper.toNumber(this.items[index].editSpecs.BM.adj) : null)
            // this.items[index].editSpecs.DISTRI.adj = (this.items[index].editSpecs.DISTRI.adj ? this.$helper.toNumber(this.items[index].editSpecs.DISTRI.adj) : null)
            // this.items[index].editSpecs.REKONDISI.adj = (this.items[index].editSpecs.REKONDISI.adj ? this.$helper.toNumber(this.items[index].editSpecs.REKONDISI.adj) : null)
            this.items[index].editSpecs.RESMI.adj = (this.items[index].editSpecs.RESMI.adj ? this.$helper.toNumber(this.items[index].editSpecs.RESMI.adj) : null)

            let payload = {
                id: this.items[index].id,
                adjBatangan: this.items[index].editBatangan != "" ? this.$helper.toNumber(this.items[index].editBatangan) : null,
                adjS: (this.items[index].editGradeS ? this.$helper.toNumber(this.items[index].editGradeS) : null),
                adjSpec: Object.entries(this.items[index].editSpecs).map(item => item[1]),
                part: "y"
            }

            this.$axios.post("master/item/update-simple", payload).then(res => {
                if (res.status == 200) {
                    this.$helper.toastSuccess(this, "Adjustment harga berhasil disimpan!")
                    this.items[index].editBatangan = ""
                    this.items[index].editGradeS = ""
                    for (const [key, _] of Object.entries(this.items[index].editSpecs)) {
                        this.items[index].editSpecs[key].adj = ""
                    }
                    this.items[index].isEditing = false
                    this.items[index].isSubmitting = false
                    this.getItems()
                }
                else {
                    this.$helper.toastError(this, "Terjadi kesalahan pada server, silahkan coba lagi")
                    this.items[index].isSubmitting = false
                }
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.items[index].isSubmitting = false
                })
        },

        sanitizeAll(index, item) {
            this.sanitize(index, item, "editBatangan")
            this.sanitize(index, item, "editGradeS")
            this.sanitize(index, item, "BM")
            // this.sanitize(index, item, "DISTRI")
            this.sanitize(index, item, "REKONDISI")
            this.sanitize(index, item, "RESMI")
        },

        sanitize(index, item, column) {
            if (column == "editBatangan") {
                let cleaned = String(item.editBatangan).replace(/\./g, "")
                let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                item.editBatangan = res
            } else if (column == "editGradeS") {
                let cleaned = String(item.editGradeS).replace(/\./g, "")
                let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                item.editGradeS = res
            } else if (column == "BM") {
                let cleaned = String(item.editSpecs.BM.adj).replace(/\./g, "")
                let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                item.editSpecs.BM.adj = res
            } else if (column == "REKONDISI") {
                let cleaned = String(item.editSpecs.REKONDISI.adj).replace(/\./g, "")
                let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                item.editSpecs.REKONDISI.adj = res
            } else if (column == "RESMI") {
                let cleaned = String(item.editSpecs.RESMI.adj).replace(/\./g, "")
                let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                item.editSpecs.RESMI.adj = res
            }
            // else if(column == "DISTRI"){
            //     let cleaned = String(item.editSpecs.DISTRI.adj).replace(/\./g, "")
            //     let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            //     item.editSpecs.DISTRI.adj = res
            // }

        },

    },
    created() {
        this.init()
    }
}
</script>
